import * as React from "react";
const SvgFiRrCheeseburger = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cheeseburger_svg__a)">
      <path
        fill="#062147"
        d="M3.066 12.001H20.94c.568 0 1.11-.243 1.49-.667a2.02 2.02 0 0 0 .504-1.565C22.325 4.2 17.625 0 12.004 0A10.977 10.977 0 0 0 1.072 9.767a2.02 2.02 0 0 0 .5 1.566c.38.425.925.668 1.494.668m8.938-10c4.6 0 8.444 3.433 8.938 8H3.066l-.007-.012a8.986 8.986 0 0 1 8.945-7.988m-11 13a1 1 0 0 1 1-1h19.999a1 1 0 0 1 0 2h-3l-2.544 2.544a1.35 1.35 0 0 1-1.911 0l-2.544-2.544h-10a1 1 0 0 1-1-1m22 5c0 2.206-1.794 4-4 4h-14c-2.206 0-4-1.794-4-4 0-1.103.897-2 2-2h7.999a1 1 0 0 1 0 2h-8c0 1.103.898 2 2 2h14c1.104 0 2-.897 2-2h-1a1 1 0 0 1 0-2h1c1.104 0 2 .897 2 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cheeseburger_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCheeseburger;
